import moment from "moment";
import momentTz from "moment-timezone";
import * as messages from "../assets/Json/messages.json";
import config from "../assets/Json/config.json";
import {
	instancesMutations,
	registrationMutations,
	usersMutations,
} from "../Store/store.js";

export const helper = {
	formatDateTime: (utcDateString) => {
		return utcDateString
			? momentTz(utcDateString).tz("Europe/London").format("DD/MM/YYYY HH:mm")
			: "";
	},

	formatDate: (utcDateString) => {
		return utcDateString
			? momentTz(utcDateString).tz("Europe/London").format("DD/MM/YYYY")
			: "";
	},

	formatCurrency: (amount) => {
		amount = amount ?? 0;
		const amountStr = `£${amount.toFixed(2)}`;
		return amountStr === "£-0.00" ? "£0.00" : amountStr;
	},

	validateEmail: (email) => {
		const emailRegularExpression =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegularExpression.test(String(email).toLowerCase());
	},
	canRegisterEmail: async (email) => {
		var canRegister = true;
		let request = {
			email: email,
			tokenKey: config.businessTokenKey,
		};
		try {
			let res = await registrationMutations.canRegisterEmail(request);
			canRegister = res.data.success;
		} catch (error) {
			canRegister = false;
		}
		return !!canRegister;
	},
	userCanRegisterEmail: async (email, userId) => {
		var canRegister = true;
		let request = {
			email: email,
			tokenKey: config.businessTokenKey,
			userId: userId,
		};
		try {
			let res = await usersMutations.canRegisterEmail(request);
			canRegister = res.data.success;
		} catch (error) {
			canRegister = false;
		}
		return !!canRegister;
	},
	validateEmails: (emails) => {
		const emailList = emails.split(",");

		for (let index in emailList) {
			if (!helper.validateEmail(emailList[index])) {
				return false;
			}
		}

		return true;
	},
	emailValidator: async (rule, value, callback) => {
		if (!helper.validateEmail(value)) {
			callback("Please input valid email address!");
		} else if (!(await helper.canRegisterEmail(value))) {
			callback("Email already registered!");
		} else {
			callback();
		}
	},
	userEmailValidator: async (rule, value, callback) => {
		if (!helper.validateEmail(value)) {
			callback("Please input valid email address!");
		} else if (!(await helper.userCanRegisterEmail(value))) {
			callback("Email already registered!");
		} else {
			callback();
		}
	},

	urlValidator: (rule, value, callback) => {
		if (helper.validateURL(value)) {
			callback();
		}
		callback("Please input a valid URL (it has to start with http://)");
	},
	validateURL: (url) =>
		new RegExp(
			/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?\/$/
		).test(url),
	subdomainValidator: (rule, value, callback) => {
		helper
			.validateSubdomain(value)
			.then((val) =>
				val ? callback() : callback("Your Subdomain Is Invalid.")
			);
	},
	validateSubdomain: async (url) => {
		var canRegister = true;
		try {
			var response = await instancesMutations.isSubdomainValid(url);
			canRegister = response;
		} catch (error) {
			canRegister = false;
		}
		return canRegister;
	},

	nameValidator: (rule, value, callback) => {
		if (helper.validateName(value)) {
			callback();
		}
		callback("Please input a valid name");
	},
	validateName: (name) => new RegExp(/^[a-zA-Z ]+$/).test(name),

	dateFormatValidator: (rule, value, callback) => {
		if (!helper.validateDateFormat(value)) {
			callback("Please input a valid date");
		}
		// else if (!helper.validateDateGreaterThanNow(value)) { callback('Date has to be in the future!'); }
		else {
			callback();
		}
	},
	validateDateFormat: (date) =>
		new RegExp(
			/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
		).test(date),
	validateDateGreaterThanNow: (date) => {
		return moment().diff(moment(date, "DD/MM/YYYY"), "days") <= 0;
	},

	validatePhoneNumber: (phone) => new RegExp(/^([0-9]{5,})$/).test(phone),
	phoneValidator: (rule, value, callback) => {
		if (!helper.validatePhoneNumber(value))
			callback("Please input a valid phone number");
		else callback();
	},
	validateVerifyCode: (code) => new RegExp(/^\d{4}$/).test(code),
	verifyCodeFormatValidator: (rule, value, callback) => {
		if (!helper.validateVerifyCode(value)) {
			callback(messages.verifyCodeErrorMessage);
		} else {
			callback();
		}
	},
	checkVerificationCode: async (value) => {
		let isValid = true;
		let request = {
			verificationCode: value.verificationCode,
			registrationId: value.registrationId,
		};

		try {
			let res = await registrationMutations.verifyEmailAddress(request);
			isValid = res.data.success;
		} catch (error) {
			isValid = false;
		}
		return !!isValid;
	},
	verifyCodeValidator: async (rule, value, callback) => {
		if (!(await helper.checkVerificationCode(value))) {
			callback(messages.verifyCodeWrongCodeMessage);
		} else {
			callback();
		}
	},
	getFileNameFromResponse(response) {
		try {
			var contentDisposition = response.headers["content-disposition"];
			return contentDisposition.split("filename=")[1].split(";")[0];
		} catch {
			return "";
		}
	},
	inputNumberValidator: async (rule, value, callback) => {
		if (helper.validateInputNumber(value)) {
			callback();
		}
		callback("Please input a valid Number");
	},
	validateInputNumber: (value) => +value > 0,
};
